import { toastActions } from "./index";
import { logError } from "trackers";
import { navigate } from "gatsby";

export const toastMiddleware = () => next => async action => {
  try {
    return await next(action);
  } catch (e) {
    if (e.response) {
      const { data: body } = e.response;
      if (!body) {
        toastActions.showToast("An unkown error occurred");
        logError(e, { info: "TMW: no body" });
        throw e;
      }
      // token is not set, redirect to login
      if (body.detail === "Authentication credentials were not provided.") {
        toastActions.showToast("You are not logged in.");
        return;
      }

      // or token has expired, redirect to logout
      if (body.detail === "Invalid token.") {
        navigate("/dashboard/logout");
        return;
      }

      if (body.detail) {
        toastActions.showErrorToast(body.detail);
        logError(e, body);
        throw e;
      }

      if (body.non_field_errors) {
        toastActions.showErrorToast(body.non_field_errors[0]);
        logError(e, body);
        throw e;
      }

      if (
        body.email &&
        body.email.includes("account with this email already exists.")
      ) {
        toastActions.showErrorToast(
          "You have already registered an account with this e-mail."
        );
      }
      logError(e, { info: "From backend", body });
      toastActions.showToast(`Server says ${JSON.stringify(body)}`);
      throw e;
    }

    if (window.navigator && !window.navigator.onLine) {
      toastActions.showErrorToast(
        "The internet connection appears to be offline, sorry ☹"
      );
    }

    logError(e, { info: "unkown error" });
    toastActions.showToast("An unkown error occurred");
    throw e;
  }
};
